
export const zh: { [key: string]: { [key: string]: string } } = {
    common: {
        register: "Registro",
        login: "Entrar"
    }
};
